import React, { useEffect } from "react";
import Container from "react-bootstrap/Container";
import "../../../assets/styles/pages/homeCss/sections.css";
import AOS from "aos";
import Client from "./Client";

const Sections = () => {

  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, [])

  return (
    <>
      <Container data-aos='fade-up' fluid>
        <div className="section-main">
          <div className="text-center section-main-head ">
            Trusted by Top Organizations<br />
          </div>
          <div className=" mt-5">

            <Client />
          </div>
        </div>
      </Container>
    </>
  );
};

export default Sections;
